<template>
  <div class="flex flex-col h-full">
    <!-- Верхний блок (фиксированная высота или по содержимому) -->
    <div class="flex-1">
      <table class="min-w-full divide-y divide-gray-400 text-left">
        <thead class="bg-gray-700 text-gray-300 text-xs font-medium">
        <tr>
          <th v-for="(column, index) in columns" v-bind:key="index" scope="col" class="px-4 py-3 w-20 tracking-wider">
            {{column.title}}
          </th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-600 h-full">
          <tr v-for="(item, index) in data" v-bind:key="index" class="hover:bg-gray-800 transition-colors" @dblclick="rowDblClick(item)">
            <td v-for="(column, k) in columns" class="px-4 py-1 whitespace-nowrap text-sm font-medium text-gray-400"  v-bind:key="k">
                {{ item[column.name] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Нижний блок -->
    <div class="px-6 py-3 flex items-center justify-between border-t">
      <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <!--<div>
            <p class="text-sm text-gray-700">
              Показаны
              <span class="font-medium">1</span>
              -
              <span class="font-medium">3</span>
              из
              <span class="font-medium">3</span>
            </p>
          </div>-->
        <div>
          <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
            <a href="#" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Назад</span>
              &larr;
            </a>
            <a href="#" aria-current="page" class="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
              1
            </a>
            <a href="#" class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
              2
            </a>
            <a href="#" class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
              3
            </a>
            <a href="#" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Вперед</span>
              &rarr;
            </a>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    columns: null,
    data: {}
  },
  methods: {
    rowDblClick: function (item) {
      console.log(item);
      this.$emit('row-dblclick', item);
    }
  }
}
</script>

<style scoped>

</style>